import React, { useState } from 'react';

import { Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as MinusIcon } from '../../../../../assets/icons/minus-circle.svg';
import { ReactComponent as PlusIcon } from '../../../../../assets/icons/plus-circle.svg';
import EmptyDash from '../../../../../shared/components/EmptyDash/EmptyDash';
import { HIDE_ROW_STATE, SHOW_ROW_STATE } from '../../../../../shared/constants/constants';
import { IMembersData } from '../../../../../shared/interfaces/businessData';
import { IRowStatus } from '../../../../../shared/interfaces/collaboratorRow';
import { TRANSLATIONS_COLLABORATOR_STATUS } from '../../../../../shared/translations/collaboratorsDetail';
import { TRANSLATION_POINTS } from '../../../../../shared/translations/rewards';
import { GenericVoidFunction } from '../../../../../shared/types/genericTypes';

import './RewardsCollaboratorRow.scss';

interface IRewardsCollaboratorRow {
  collaborator: IMembersData;
  checked?: boolean;
  onCheck: GenericVoidFunction;
}

const RewardsCollaboratorRow = ({ collaborator, checked, onCheck }: IRewardsCollaboratorRow) => {
  const [rowState, setRowState] = useState<IRowStatus>(HIDE_ROW_STATE);
  const { t } = useTranslation();

  const onButtonClick = () => {
    setRowState(rowState.state === 'hide-row' ? SHOW_ROW_STATE : HIDE_ROW_STATE);
  };

  const handleCheck = () => {
    onCheck(collaborator.email);
  };

  return (
    <>
      <tr className="table-row collaborators-row">
        <td className="table-column-cell">
          <Checkbox className="checkbox" checked={checked} onChange={handleCheck} />
        </td>
        <td className="table-column-cell">{collaborator.email}</td>
        <td className="table-column-cell">
          {collaborator.nationalIdentifications?.idValue ? collaborator.nationalIdentifications.idValue : <EmptyDash />}
        </td>
        <td className="table-hide-tablet">{collaborator.fullName ? collaborator.fullName : <EmptyDash />}</td>
        <td className="table-hide-tablet">
          <div className={`collaborator-state ${collaborator.status}`}>
            {t(TRANSLATIONS_COLLABORATOR_STATUS[collaborator.status])}
          </div>
        </td>
        <td className="tablet-mobile-only data">
          <div className="icon toggle-info" onClick={onButtonClick}>
            <PlusIcon className={rowState.plusClass} data-testid="plus-icon" />
            <MinusIcon className={rowState.minusClass} data-testid="minus-icon" />
          </div>
        </td>
      </tr>
      <tr className="tablet-mobile-only row collaborators-row">
        <td colSpan={4}>
          <div className={`collapsable-section ${rowState.state}`}>
            <div className="section-container">
              <div className="item-title">{t(TRANSLATION_POINTS.send_points.table.header.name)}</div>
              <div className="item-value">{collaborator.fullName ? collaborator.fullName : <EmptyDash />}</div>
            </div>
            <div className="section-container">
              <div className="item-title">{t(TRANSLATION_POINTS.send_points.table.header.status)}</div>
              <div className="item-value">
                <div className={`collaborator-state ${collaborator.status}`}>
                  {t(TRANSLATIONS_COLLABORATOR_STATUS[collaborator.status])}
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </>
  );
};

export default RewardsCollaboratorRow;
